import QuoteItemMatchSelector from "@/components/quote-item-match-selector";
import type { QuoteItem, RequestItem } from "@/types";

interface HasModel<T> {
  model: T;
}
interface WithExtras {
  availableRequestItems?: RequestItem[];
  matchedRequestItemIds?: Set<number>;
  organizationSlug?: string;
}

const hasModel = <T,>(p: unknown): p is HasModel<T> =>
  typeof p === "object" && p !== null && "model" in (p as Record<string, unknown>);

// 'model' es el quoteItem. 'availableRequestItems' se lo pasamos como prop extra.
export const MatchSelectorCell = (props: unknown) => {
  let item: QuoteItem;
  if (hasModel<QuoteItem>(props)) {
    item = props.model;
  } else {
    item = props as QuoteItem;
  }
  const availableRequestItems = (props as WithExtras)?.availableRequestItems ?? [];
  const matchedRequestItemIds =
    (props as WithExtras)?.matchedRequestItemIds ?? new Set();
  const organizationSlug = (props as WithExtras)?.organizationSlug ?? "";

  return (
    <div className="flex items-center h-full p-1">
      <QuoteItemMatchSelector
        quoteItem={item}
        availableRequestItems={availableRequestItems}
        matchedRequestItemIds={matchedRequestItemIds}
        organizationSlug={organizationSlug}
      />
    </div>
  );
};
